import { useState, useRef } from "react";
import It from "../../../assets/Home-Page-Assets/It-only-gets-better.png";
import Button from "../../../components/Buttons/Button";
import { sendFormEmail } from "../../../lib/sendEmail";

const JoinUsComponents = () => {
  const formRef = useRef(null);
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    phone: "",
    role: "",
    where: "",
    cvLink: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, phone, role, where, cvLink } = formValues;

    setIsSubmitting(true);
    setError("");

    try {
      await sendFormEmail("join", { name, email, phone, role, where, cvLink });

      window.location.href = `/confirmation?type=contact${name ? `&name=${encodeURIComponent(name)}` : ''}${email ? `&email=${encodeURIComponent(email)}` : ''}&message=${encodeURIComponent('Thank you for your interest in joining our team! We will review your application and get back to you soon.')}`;

      setFormValues({
        name: "",
        email: "",
        phone: "",
        role: "",
        where: "",
        cvLink: "",
      });
      formRef.current?.reset();
    } catch (submitError) {
      console.error("Failed to send email:", submitError);
      setError("Error sending email. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="JoinUsComponents">
      <div className="container">
        <div className="form-section">
          <div className="my-6 text-center">
            <h2 className="font-bold text-[var(--navy-blue)]">
              Further your career at Belsoft
            </h2>
          </div>
          <div className="form-content">
            <div className="itImage">
              <img src={It} alt="Belsoft Systems" className="w-20" />
            </div>
            <form ref={formRef} onSubmit={handleSubmit} aria-busy={isSubmitting}>
              <div className="field-style">
                <label htmlFor="name" className="label-style">
                  Full Name:
                </label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  placeholder="Enter Full Name"
                  className="input-style"
                  onChange={handleInputChange}
                  value={formValues.name}
                  required
                  disabled={isSubmitting}
                />
              </div>
              <div className="field-style">
                <label htmlFor="email" className="label-style">
                  E-mail:
                </label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Enter Email Address"
                  className="input-style"
                  onChange={handleInputChange}
                  value={formValues.email}
                  required
                  disabled={isSubmitting}
                />
              </div>
              <div className="field-style">
                <label htmlFor="phone" className="label-style">
                  Phone Number:
                </label>
                <input
                  type="tel"
                  name="phone"
                  id="phone"
                  placeholder="Enter Phone Number"
                  className="input-style"
                  onChange={handleInputChange}
                  value={formValues.phone}
                  required
                  disabled={isSubmitting}
                />
              </div>
              <div className="field-style">
                <label htmlFor="role" className="label-style">
                  Role:
                </label>
                <input
                  type="text"
                  name="role"
                  id="role"
                  placeholder="What role would you like to apply for?"
                  className="input-style"
                  onChange={handleInputChange}
                  value={formValues.role}
                  required
                  disabled={isSubmitting}
                />
              </div>
              <div className="field-style">
                <label htmlFor="where" className="label-style">
                  Where did you hear about us please?
                </label>
                <textarea
                  name="where"
                  id="where"
                  rows={5}
                  placeholder="Type Here..."
                  className="input-style"
                  onChange={handleInputChange}
                  value={formValues.where}
                  required
                  disabled={isSubmitting}
                />
              </div>
              <div className="field-style">
                <label htmlFor="cvLink" className="label-style">
                  Link to your CV (Google Drive or LinkedIn only):
                </label>
                <input
                  type="url"
                  name="cvLink"
                  id="cvLink"
                  placeholder="Paste your CV link here"
                  className="input-style"
                  onChange={handleInputChange}
                  value={formValues.cvLink}
                  required
                  disabled={isSubmitting}
                />
              </div>
              {error && <p className="form-error" role="alert">{error}</p>}
              <div className="field-style">
                <Button text={isSubmitting ? "Sending..." : "Submit"} type="submit" disabled={isSubmitting} />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JoinUsComponents;
